// eslint-disable-next-line no-unused-vars
import ChatRepository from '../../../domain/repositories/ChatRepository';
// eslint-disable-next-line no-unused-vars
import Conversation from '../../../domain/entities/Conversation';

class GetConversationByIdUseCase {
    /**
     * @param {ChatRepository} chatRepository
     */
    constructor(chatRepository) {
        this.chatRepository = chatRepository;
    }

    /**
     * Retrieves a conversation by its ID.
     * @param {string} conversationId
     * @returns {Promise<Conversation>}
     */
    async execute(conversationId) {
        return this.chatRepository.getConversationById(conversationId);
    }
}

export default GetConversationByIdUseCase;
